import { credentialsVar } from '../../cache/auth'
import { ENV } from '../../config/env'

let downloadSequence = 0

export function tenantExportDownloadAuthorization(
  accessToken?: string
): string {
  const token = accessToken?.trim()
  if (!token) return ''
  return token.toLowerCase().startsWith('bearer ') ? token : `Bearer ${token}`
}

export async function downloadTenantDataExportArtifact(
  artifactId: string,
  downloadBaseUrl = ENV.GRAPH_BFF || window.location.origin,
  accessToken = credentialsVar()?.accessToken
): Promise<void> {
  const url = `${downloadBaseUrl.replace(
    /\/$/,
    ''
  )}/tenant-data-exports/${artifactId}/download`

  const target = `tenant-export-download-${artifactId}-${++downloadSequence}`
  const iframe = document.createElement('iframe')
  iframe.name = target
  iframe.style.display = 'none'

  const form = document.createElement('form')
  form.method = 'POST'
  form.action = url
  form.target = target
  form.style.display = 'none'

  const authorization = tenantExportDownloadAuthorization(accessToken)
  if (authorization) {
    const tokenInput = document.createElement('input')
    tokenInput.type = 'hidden'
    tokenInput.name = 'authorization'
    tokenInput.value = authorization
    form.appendChild(tokenInput)
  }

  document.body.appendChild(iframe)
  document.body.appendChild(form)
  try {
    form.submit()
  } catch (error) {
    iframe.remove()
    throw error
  } finally {
    form.remove()
  }
  // Attachment downloads do not reliably fire an iframe load event. Keep the
  // target for this page's lifetime rather than aborting a slow transfer.
}
